import colors from 'shared-tokens/utils/tokens/colors';
import createTransition from 'shared-tokens/utils/createTransition';
import createBreakpoint from 'shared-tokens/utils/breakpoints';

import { mainCls as baseCls } from '../../style';

const brpM = createBreakpoint('m');

export const mainCls = `${baseCls}__footer`;

export default {
  [mainCls]: {
    width: '100%',
    // '&:before': {
    //   content: '""',
    //   position: 'absolute',
    //   top: 0,
    //   left: 0,
    //   width: '100%',
    //   height: 1,
    //   backgroundImage: 'linear-gradient(90deg, #96a1b0 20%,rgba(255, 255, 255, 0) 0)',
    //   backgroundPosition: 0,
    //   backgroundSize: '4px 1px',
    //   backgroundRepeat: 'repeat-x',
    // },
  },
  [`${mainCls}__btn`]: {
    display: 'flex',
    alignItems: 'center',
    background: 'transparent',
    border: '0 none',
    transition: createTransition(['color']),
    '& svg': {
      marginTop: -2,
    },
    [brpM]: {
      '&:hover': {
        color: `${colors.f0.rgba} !important`,
      },
    },
  },
};